import styled from 'styled-components';

export const MainContainer = styled.div`
  position: relative;
  padding: 48px 55px;
  margin-top: 10px;
`;
